import { createContext, useContext } from 'react';

// This context should have all the variables used in the card location query

const CardLocationContext = /*#__PURE__*/createContext({
  additionalLocationData: {
    objectId: undefined,
    objectTypeId: undefined
  },
  features: new Set(),
  location: 'UNKNOWN',
  propertySource: 'CRM_UI',
  usageTracker: undefined,
  enableVirtualization: false
});
export const CardLocationContextProvider = CardLocationContext.Provider;
export const useCardLocationContext = () => useContext(CardLocationContext);